module.exports = __webpack_public_path__ + "img/404error-dark.0f9e8afa.svg";